interface ClarityAPI {
  (method: "event", eventName: string): void;
}

declare global {
  interface Window {
    clarity?: ClarityAPI;
  }
}

export const trackEvent = ({
  category,
  action,
  name,
}: {
  category: string;
  action: string;
  name: string;
}) => {
  if (window?.clarity) {
    window.clarity("event", `${category}, ${action}, ${name}`);
  }
};
